module.exports = __webpack_public_path__ + "static/media/floor_wooden_plywood.abd365df.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_wooden_plywood.png
 ** module id = 957
 ** module chunks = 0
 **/